import React from "react"
import PropTypes from "prop-types"

import ComponentError from "ui-ComponentError"

export const styleSheet = theme => ({
  section: {
    marginTop: theme.spacing.unit * -3,
    marginBottom: theme.spacing.unit * 3,
  },

  container: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,

    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
  },
})

function StaticDialogError({
  classes,
  className: classNameProp,
  section,

  ...otherProps
}) {
  const className = classnames(
    classes.root,
    {
      [classes.section]: section,
    },
    classNameProp
  )

  return (
    <ComponentError {...otherProps} className={className} containerClassName={classes.container} />
  )
}

StaticDialogError.propTypes = {
  section: PropTypes.bool,
}

StaticDialogError.Actions = require("ui-ComponentError/ComponentErrorActions").default
StaticDialogError.Message = require("ui-ComponentError/ComponentErrorMessage").default

import classnames from "classnames"
import withStyles from "@material-ui/core/styles/withStyles"

export default withStyles(styleSheet)(StaticDialogError)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-StaticDialog/StaticDialogError.js